import React, { useContext, useEffect, useState } from "react";
import { Select, Button, Tag, Spin, Modal, Space } from "antd";
import callApi from "../../constants/API/CallApi";
import useApi from "../../hooks/useApi";
import { getBelts, getClasses, getKyus, GetKyuByBelt, grantKyu, updateCustomer, listProgress, getBranches, } from "../../constants/API/API";
import { Severty, ShowToast } from "../../helper/toast";
import { AppStateContext } from "../../context/AppContext";
import CustomTable from "../../components/CustomTable";
import useFilter from "../../hooks/useFilter";
const { Option } = Select;


const StudentProgressManagement = () => {
  const { setPageHeading } = useContext(AppStateContext);
  setPageHeading("Student Progress Management");
  const [progressData, setProgressData] = useState([]);
  const [grantLoading, setGrantLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [selected, setSelected] = useState(null);
  const [grantModalVisible, setGrantModalVisible] = useState(false);
  const [selectedKyu, setSelectedKyu] = useState(null);
  const [kyuOptions, setKyuOptions] = useState([]);
  const [totalDocs, setTotalDocs] = useState(0);
  const [, setClassList] = useState([]);
  const [belts, setBelts] = useState([]);
  const [filters, setFilters] = useFilter({
    sortField: "createdOn",
    sort: "desc",
    studentId: undefined,
    beltId: undefined,
    classId: undefined,
    branchId: undefined,
    status: undefined,
    kyuId: null,
    eligible: null,
  });
  const [editBeltModal, setEditBeltModal] = useState(false);
  const [selectedStudentForBelt, setSelectedStudentForBelt] = useState(null);
  const [updateBeltLoading, setUpdateBeltLoading] = useState(false);
  const [kyuOptionsForFilter, setKyuOptionsForFilter] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);

  useApi({
    callback: getBranches,
    dependencies: [refresh],
    shouldCallApi: true,
    onSuccess: ({ data }) => {
      const activeBranches = (data || []).filter((branch) => branch.isActive);
      setBranches(activeBranches);
    },
  });

  useApi({
    callback: getBelts,
    payload: selectedBranch ? { branchId: selectedBranch } : null,
    dependencies: [selectedBranch],
    shouldCallApi: !!selectedBranch,
    onSuccess: ({ data }) => {
      setBelts(data);
    },
  });

  useApi({
    callback: GetKyuByBelt,
    payload: {
      beltId: filters.beltId,
    },
    dependencies: [filters.beltId],
    shouldCallApi: !!filters.beltId,
    onSuccess: (response) => {
      console.log("GetKyuByBelt response", response);
      setKyuOptionsForFilter(response?.kyus || []);
    },

    onError: () => {
      setKyuOptionsForFilter([]);
    },
  });

  const { loading: isProgressLoading } = useApi({
    callback: listProgress,
    payload: filters,
    dependencies: [refresh, filters],
    shouldCallApi: true,
    onSuccess: (data) => {
      console.log(data);
      setProgressData(data?.docs || []);
      setTotalDocs(data?.totalDocs || 0);
    },
    onError: (err) => {
      console.log(err);
    },
  });

  useApi({
    callback: getKyus,
    payload: {
      value: selected?.kyu?.requiredClasses,
      beltId: selected?.beltId,
      userId: selected?.user?._id,
    },
    dependencies: [selected, refresh],
    shouldCallApi: true,
    onSuccess: (data) => {
      console.log(data);
      setKyuOptions(data?.data || []);
    },
    onError: (err) => {
      console.log(err);
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [classRes, belts] = await Promise.all([getClasses()]);
        setBelts(belts?.data?.data || []);
        setClassList(classRes?.data?.data || []);
      } catch (error) {
        setBelts([]);
        setClassList([]);
      }
    };
    fetchData();
  }, []);

  const handleGrantKyu = () => {
    if (!selectedKyu) {
      return ShowToast("Please select next kyu to grant!", "error");
    }
    setGrantLoading(true);
    callApi({
      callback: grantKyu,
      payload: { progressId: selected?._id, nextKyuId: selectedKyu },
      onSuccess: ({ message }) => {
        ShowToast(message, Severty.SUCCESS);
        setRefresh((x) => !x);
        setGrantModalVisible(false);
        setSelected(null);
        setSelectedKyu(null);
        setGrantLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setGrantLoading(false);
      },
    });
  };

  const handleEditBelt = async (record) => {
    setSelectedStudentForBelt(record);
    setEditBeltModal(true);

    try {
      const branchId = record?.parent?.branchId;
      const beltsRes = await getBelts(branchId ? { branchId } : {});
      setBelts(beltsRes?.data?.data || []);
    } catch (error) {
      setBelts([]);
      ShowToast("Failed to fetch belts", Severty.ERROR);
    }
  };

  const handleUpdateBelt = () => {
    if (!selectedStudentForBelt?.newBelt) {
      return ShowToast("Please select a belt!", "error");
    }

    setUpdateBeltLoading(true);

    callApi({
      callback: updateCustomer,
      payload: [
        { beltId: selectedStudentForBelt.newBelt },
        selectedStudentForBelt.userId,
      ],
      onSuccess: ({ message }) => {
        ShowToast(message, Severty.SUCCESS);
        setRefresh((x) => !x);
        setEditBeltModal(false);
        setSelectedStudentForBelt(null);
        setUpdateBeltLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setUpdateBeltLoading(false);
      },
    });
  };

  const columns = [
    {
      title: "Student",
      dataIndex: ["user", "name"],
      key: "name",
    },
    {
      title: "Parent",
      dataIndex: ["parent", "name"],
      key: "parentName",
      render: (_, record) => record?.parent?.name || "N/A",
    },
    {
      title: "Branch",
      dataIndex: ["branch", "name"],
      key: "branchName",
      render: (_, record) => record?.branch?.name || "N/A",
    },

    {
      title: "Belt",
      dataIndex: ["belt", "name"],
      render: (_, record) => (
        <Button type="link" onClick={() => handleEditBelt(record)}>
          {record?.belt?.name || "N/A"}
        </Button>
      ),
    },

    // {
    //   title: "Class",
    //   dataIndex: ["class", "name"],
    // },
    {
      title: "Kyu",
      dataIndex: ["kyu", "name"],
    },
    {
      title: "Belt Classes",
      render: (_, record) => {
        return <span>{record?.totalClasses || 0}</span>;
      },
    },
    {
      title: "Kyu Attendance",
      render: (_, record) => {
        const { extraClasses = 0, attendedClasses = 0 } = record;
        if (extraClasses < 0) {
          return (
            <span style={{ color: "red", fontWeight: 600 }}>
              {extraClasses}
            </span>
          );
        }

        return <span>{attendedClasses}</span>;
      },
    },
    {
      title: "Eligibility",
      render: (_, record) => {
        const eligible = record.eligible;
        return (
          <Tag
            color={
              eligible || record?.kyu?.triggersGraduationEligibility
                ? "green"
                : "red"
            }
          >
            {eligible || record?.kyu?.triggersGraduationEligibility
              ? "Eligible"
              : "Not Eligible"}
          </Tag>
        );
      },
    },
    {
      title: "Kyu Status",
      render: (_, record) => {
        return (
          <Tag
            color={
              record.status === "paused"
                ? "orange"
                : record?.kyu?.triggersGraduationEligibility
                  ? "green"
                  : "blue"
            }
          >
            {record?.kyu?.triggersGraduationEligibility
              ? "Eligible"
              : record.status}
          </Tag>
        );
      },
    },
    {
      title: "Actions",
      render: (_, record) => {
        return (
          <Button
            type="primary"
            disabled={!!record?.kyu?.triggersGraduationEligibility}
            onClick={() => {
              setGrantModalVisible(true);
              setSelected(record);
            }}
          >
            {!!record?.kyu?.triggersGraduationEligibility
              ? "Ready for Exam"
              : "Grant Kyu"}
          </Button>
        );
      },
    },
  ];

  const handleFilterChange = (key) => (value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
      ...(key === "beltId" && { kyuId: undefined }),
      page: 1,
    }));

    if (key === "beltId") {
      setKyuOptionsForFilter([]);
    }
  };

  const renderFilters = () => (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
      <Space>
        {/* <Select
          allowClear
          style={{ width: 200 }}
          placeholder="Filter by Class"
          onChange={handleFilterChange("classId")}
          value={filters.classId}
          options={classList?.map((cls) => ({
            label: cls.name,
            value: cls._id,
          }))}
        /> */}

        <Select
          placeholder="Select Branch"
          style={{ width: 200 }}
          allowClear
          onChange={(branchId) => {
            setSelectedBranch(branchId);

            setFilters((prev) => ({
              ...prev,
              branchId: branchId,
              beltId: undefined,
              kyuId: undefined,
              page: 1,
            }));

            setKyuOptionsForFilter([]);
          }}
        >
          {branches?.map((branch) => (
            <Select.Option key={branch?._id} value={branch?._id}>
              {branch?.name}
            </Select.Option>
          ))}
        </Select>
        <Select
          allowClear
          style={{ width: 200 }}
          placeholder="Filter by Belt"
          onChange={handleFilterChange("beltId")}
          value={filters.beltId}
          options={belts?.map((belt) => ({
            label: belt.name,
            value: belt._id,
          }))}
        />

        <Select
          placeholder="Select Kyu"
          style={{ width: "200px" }}
          allowClear
          value={filters.kyuId}
          onChange={(value) =>
            setFilters((prev) => ({ ...prev, kyuId: value }))
          }
        >
          {kyuOptionsForFilter.map((kyu) => (
            <Option key={kyu._id} value={kyu._id}>
              {kyu.name}
            </Option>
          ))}
        </Select>
        <div>
          <Select
            placeholder="Select Eligibility"
            style={{ width: "200px" }}
            allowClear
            value={filters.eligible}
            onChange={(value) =>
              setFilters((prev) => ({ ...prev, eligible: value }))
            }
          >
            <Option value={true}>Eligible</Option>
            <Option value={false}>Not Eligible</Option>
          </Select>
        </div>
      </Space>
    </div>
  );

  const loading = !!isProgressLoading;

  return (
    <div>
      <CustomTable
        data={progressData}
        loading={loading}
        filters={filters}
        setFilters={setFilters}
        columns={columns}
        fields={{ range: false, search: true }}
        totalDocs={totalDocs}
        searchField={["name"]}
        searchPlaceholder={"Search by Student Name"}
        customFilter={renderFilters}
        hideAddButton
      />

      <Modal
        open={grantModalVisible}
        title="Grant Next Kyu"
        onOk={handleGrantKyu}
        confirmLoading={grantLoading}
        onCancel={() => {
          setGrantModalVisible(false);
          setSelectedKyu(null);
        }}
        okText="Grant"
      >
        <p>Select the next Kyu to assign:</p>
        <Select
          placeholder="Select Kyu"
          style={{ width: "100%" }}
          value={selectedKyu}
          onChange={(value) => setSelectedKyu(value)}
        >
          {kyuOptions.map((kyu, idx) => (
            <Option key={kyu?._id} value={kyu?._id}>
              {kyu.name}
              <span style={{ float: "right", color: "#999" }}>
                {kyu.priorityNumber ?? "N/A"}
              </span>
            </Option>
          ))}
        </Select>
      </Modal>


      <Modal
        open={editBeltModal}
        title="Update Student Belt"
        onOk={handleUpdateBelt}
        okText="Update"
        confirmLoading={updateBeltLoading}
        onCancel={() => {
          setEditBeltModal(false);
          setSelectedStudentForBelt(null);
        }}
      >
        <p>Select Belt</p>
        <Select
          placeholder="Select Belt"
          style={{ width: "100%" }}
          value={selectedStudentForBelt?.newBelt}
          onChange={(value) =>
            setSelectedStudentForBelt((prev) => ({ ...prev, newBelt: value }))
          }
        >
          {belts?.map((belt) => (
            <Option key={belt._id} value={belt._id}>
              {belt.name}

            </Option>
          ))}
        </Select>
      </Modal>



    </div>
  );
};

export default StudentProgressManagement;
